import React, { Component } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import Select from 'react-select';
//import 'react-select/dist/react-select.css';

// Import dependencies - assuming these exist or need to be adapted
import SummernoteCorgee from '@components/Globals/SummernoteCorgee';
import CorgeeStorageHelper from '@components/Globals/CorgeeStorageHelper';
import FileUpload from '@components/Globals/FileUpload';
import CustomModal from '@components/Globals/CustomModal';
import CardConversationLayers from '@components/Globals/CardConversationLayers';
import ReplyApi from './api/ReplyApi';
import ConversationApi from './api/ConversationApi';
import { conversationBus } from '@lib/conversationBus';
import './ConversationCardAddReply.css';

// Type definitions
interface Layer {
  LayerId: number;
  LayerColor?: string;
  Color?: string;
  LayerName?: string;
  Name?: string;
  PriorityInConfigValue?: number;
}

interface ConversationLayer extends Layer {}

interface ReplyLayer {
  LayerId: number;
  LayerColor: string;
  LayerName: string;
  ReplyId: number;
  PriorityInConfigValue?: number;
}

interface Attachment {
  AllowedSize?: boolean;
  Progress?: number;
  [key: string]: unknown;
}

interface Tag {
  PersonId: number;
  ConversationId: number;
  ReplyId: number;
  ReplyFollowing: number;
}

interface PhaseOption {
  value: number;
  label: string;
}

interface ReplyItem {
  ReplyId: number;
  ConversationId: number;
  ReplyLayers: ReplyLayer[];
  Attachments: Attachment[];
  Body: string;
  Tags: Tag[];
  SocketConnectionId: string;
  possibleTags?: unknown[];
  type: number;
  CreatedBy?: string;
  ImageName?: string;
  CopyBody?: string;
  TemporalReply?: boolean;
  reactSelfUpdate?: boolean;
  ConversationPhaseId?: number;
  PhaseName?: string;
  ReplyId_Repost?: number;
  CreatedAt?: string;
  CreatedById?: number;
  IsEnable?: boolean;
  IsFavorite?: boolean;
  FavoriteCount?: number;
  OriginalConversationId?: number;
  IsImportant?: boolean;
  reactions?: unknown[];
}

interface Conversation {
  ConversationId: number;
  ConversationLayers?: ConversationLayer[];
  HasPhases?: boolean;
  Phases?: Phase[];
  ProjectId: number;
  ConfigValueId?: number;
  CreatedBy?: string;
  isAddLayertoCard?: boolean;
}

interface Phase {
  ConversationPhaseId: number;
  Title: string;
}

interface UserData {
  personName?: string;
  imageProfile?: string;
}

interface CoregeeFunctions {
  onUpdateReply?: (
    conversation: Conversation,
    reply: ReplyItem,
    update: Record<string, unknown>,
    param: number
  ) => void;
  loadingBarStart?: () => void;
  loadingBarComplete?: () => void;
  getSocketConnectionId?: () => string;
}

interface ConversationCardAddReplyProps {
  conversation: Conversation;
  api: unknown;
  isConversationDetailsView?: boolean;
  isInfowindowViewCard?: boolean;
  itemRepost?: ReplyItem;
  openRepost?: boolean;
  setShowRepost?: () => void;
  userData?: UserData;
  config: { weburl: string };
  SocketConnectionId?: string;
  corgeeFunctions?: CoregeeFunctions;
  phaseSelected?: Phase;
  onAddReply?: (
    conversationId: number,
    reply: ReplyItem,
    isUpdate: boolean,
    isNew: boolean
  ) => void;
  setIsFromAddReply?: (value: boolean) => void;
  onAddLayerToCard?: unknown;
  onAddLayerToProject?: unknown;
  onSetFunctionsCardLayers?: unknown;
}

interface ConversationCardAddReplyState {
  isEnableEditor: boolean;
  body: string;
  attachments: Attachment[];
  layers: ConversationLayer[];
  layersSelectedIds: number[];
  layersSelected: ConversationLayer[];
  listMenuStyle: CSSProperties;
  showBodyIsRequired: boolean;
  showLayerIsRequired: boolean;
  saveInProgress: boolean;
  isNewRepost: boolean;
  isLoadingRepost: boolean;
  previousBody: string;
  buttonTitle: string;
  type: number;
  functionCallback: unknown;
  isUploadingFile: boolean;
  showConfirmationModal: boolean;
  comboPhaseSelected: number;
  replyPhases: PhaseOption[];
  isBlockBack: boolean;
  activeLayerColor: string;
  isImportant: boolean;
}

class ConversationCardAddReply extends Component<
  ConversationCardAddReplyProps,
  ConversationCardAddReplyState
>
{
  private fileUploadItem: unknown = null;
  private summernoteCorgeeElement: unknown = null;
  private layersMultiSelectRef: unknown = null;
  private pendingImportant: boolean = false;

  constructor(props: ConversationCardAddReplyProps)
  {
    super(props);

    const layers =
      props.conversation.ConversationLayers && props.conversation.ConversationLayers.length > 0
        ? props.conversation.ConversationLayers.filter(x => x.LayerId !== 0)
        : [];

    // Use C2_layerid from localStorage to pick the default layer.
    // Availability against GetLayersByConfigValueId is validated asynchronously
    // in CardConversationLayers once fetchLayers resolves.
    const defaultLayerIdStr = localStorage.getItem('C2_layerid');
    const defaultLayerId = defaultLayerIdStr ? parseInt(defaultLayerIdStr, 10) : null;
    const defaultLayer =
      defaultLayerId != null ? layers.find(x => x.LayerId === defaultLayerId) : null;
    const initialLayer = defaultLayer || (layers.length > 0 ? layers[0] : null);

    this.state = {
      isEnableEditor: false,
      body: '',
      attachments: [],
      layers: layers,
      layersSelectedIds: initialLayer ? [initialLayer.LayerId] : [],
      layersSelected: initialLayer ? [initialLayer] : [],
      listMenuStyle: {
        left: '0px',
        top: '0px',
        position: 'fixed',
        width: '200px',
      },
      showBodyIsRequired: false,
      showLayerIsRequired: false,
      saveInProgress: false,
      isNewRepost: false,
      isLoadingRepost: false,
      previousBody: '',
      buttonTitle: 'Reply',
      type: 1,
      functionCallback: {},
      isUploadingFile: false,
      showConfirmationModal: false,
      comboPhaseSelected: 0,
      replyPhases: [],
      isBlockBack: false,
      activeLayerColor: '#ededed',
      isImportant: false,
    };

    this.onEnableEditor = this.onEnableEditor.bind(this);
    this.onKeyDownEditor = this.onKeyDownEditor.bind(this);
    this.closeEditor = this.closeEditor.bind(this);
    this.onSaveReply = this.onSaveReply.bind(this);
    this.onChangeLayer = this.onChangeLayer.bind(this);
    this.onApplyStyle = this.onApplyStyle.bind(this);
    this.onChangeSummernote = this.onChangeSummernote.bind(this);
    this.getTagsInBody = this.getTagsInBody.bind(this);
    this.setDefaultLayer = this.setDefaultLayer.bind(this);
    this.setReplyLayers = this.setReplyLayers.bind(this);
    this.onChangeFileUpload = this.onChangeFileUpload.bind(this);
    this.onRemoveAttachment = this.onRemoveAttachment.bind(this);
    this.turnOffNewRepost = this.turnOffNewRepost.bind(this);
    this.callbackDisableEditor = this.callbackDisableEditor.bind(this);
    this.handleChangePhaseSumernote = this.handleChangePhaseSumernote.bind(this);
    this.findDefaultPhase = this.findDefaultPhase.bind(this);
    this.onMarkAsImportant = this.onMarkAsImportant.bind(this);
    this.onUpdateTemporalImportant = this.onUpdateTemporalImportant.bind(this);
    this.onDropFiles = this.onDropFiles.bind(this);
    this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
    this.handlePopState = this.handlePopState.bind(this);
  }

  componentDidMount(): void
  {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', this.handlePopState);
  }

  componentWillUnmount(): void
  {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('popstate', this.handlePopState);
  }

  handleBeforeUnload = (e: BeforeUnloadEvent): void =>
  {
    if (this && this.state)
    {
      if (
        this.state.body.length > 0 &&
        (this.extractTextFromHtml(this.state.body).length > 0 ||
          this.state.attachments.length > 0 ||
          this.state.isUploadingFile)
      )
      {
        e.returnValue = '';
        e.preventDefault();
      }
    }
  };

  handlePopState = (): void =>
  {
    this.setState({
      isBlockBack: true,
    });
    this.closeEditor();
  };

  private extractTextFromHtml(html: string): string
  {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  onUpdateTemporalImportant(newImportant: boolean): void
  {
    this.pendingImportant = newImportant;
    this.setState({ isImportant: newImportant });
  }

  onMarkAsImportant(newImportant: boolean, reply: ReplyItem): void
  {
    const { conversation } = this.props;
    setTimeout(() =>
    {
      if (this.props.corgeeFunctions && this.props.corgeeFunctions.onUpdateReply)
      {
        this.props.corgeeFunctions.onUpdateReply(
          conversation,
          reply,
          { IsImportant: newImportant },
          0,
        );
      }
    }, 0);

    const requestParams = {
      ConversationId: conversation.ConversationId,
      ReplyId: reply.ReplyId,
      IsImportant: newImportant,
      SocketConnectionId:
        this.props.SocketConnectionId !== undefined && this.props.SocketConnectionId !== null
          ? this.props.SocketConnectionId
          : '',
    };

    if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarStart)
    {
      this.props.corgeeFunctions.loadingBarStart();
    }

    ConversationApi.updateReplyImportant(this.props.api as any, requestParams)
      .then(() =>
      {
        if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarComplete)
        {
          this.props.corgeeFunctions.loadingBarComplete();
        }
        ConversationApi.SetConversationsAsViewed(this.props.api as any, {
          ConversationIds: String(reply.ConversationId),
        });
      })
      .catch((error: unknown) =>
      {
        console.error(error);
      });
  }

  findDefaultPhase(): number
  {
    const phaseSelectedToolbar = this.props.conversation.HasPhases
      ? this.props.phaseSelected
        ? this.props.phaseSelected.ConversationPhaseId
        : 0
      : 0;

    const localPhasesJson = localStorage.getItem(
      CorgeeStorageHelper.appPrefix() + '_ConversationReplyPhaseDefault',
    );
    let localPhases: Array<{ ConversationId: number; ConversationPhaseId: number }> | null = null;

    try
    {
      localPhases = localPhasesJson ? JSON.parse(localPhasesJson) : null;
    }
    catch
    {
      localPhases = null;
    }

    let phaseDefault = 0;

    if (phaseSelectedToolbar > 0)
    {
      return phaseSelectedToolbar;
    }

    if (localPhases !== undefined && localPhases !== null)
    {
      for (let i = 0; i < localPhases.length; i++)
      {
        const lp = localPhases[i];
        if (lp && lp['ConversationId'] === this.props.conversation.ConversationId)
        {
          phaseDefault = lp['ConversationPhaseId'];
          break;
        }
      }
    }

    return phaseDefault;
  }

  componentDidUpdate(prevProps: ConversationCardAddReplyProps): void
  {
    // Handle layer changes when not in repost mode
    if (
      this.props.conversation &&
      prevProps.conversation &&
      this.props.conversation.ConversationId === prevProps.conversation.ConversationId &&
      !this.props.openRepost
    )
    {
      const prevLayersLength = prevProps.conversation.ConversationLayers?.length ?? 0;
      const currentLayersLength = this.props.conversation.ConversationLayers?.length ?? 0;

      if (
        currentLayersLength !== prevLayersLength &&
        currentLayersLength !== this.state.layers.length
      )
      {
        this.setState({ layers: this.props.conversation.ConversationLayers || [], type: 1 });

        setTimeout(() =>
        {
          if (this.props.conversation.isAddLayertoCard === false)
          {
            this.setDefaultLayer();
          }
        });
      }
    }

    // Handle repost mode activation
    if (this.props.openRepost && !prevProps.openRepost && !this.state.isNewRepost)
    {
      if (this.props.itemRepost)
      {
        // The reply (with its attachments) is fetched before the editor can open, which
        // can take a few seconds; show a placeholder so the click has visible feedback.
        this.setState({ isLoadingRepost: true });

        ReplyApi.getReplyById(this.props.api as any, this.props.itemRepost.ReplyId, true)
          .then((response: ReplyItem) =>
          {
            const { conversation } = this.props;

            // Build phase options here (mirroring onEnableEditor); the phase-update effect
            // below does not run on repost, so otherwise no phases would be shown.
            const phaseItems: PhaseOption[] = [];
            let conversationPhaseDefault = 0;
            if (conversation.HasPhases && conversation.Phases && conversation.Phases.length > 0)
            {
              phaseItems.push({ value: 0, label: 'All Phases' });
              for (let index = 0; index < conversation.Phases.length; index++)
              {
                const phase = conversation.Phases[index];
                if (!phase) continue;
                phaseItems.push({
                  value: phase.ConversationPhaseId,
                  label: phase.Title,
                });
              }

              // Restore the original reply's phase if available, otherwise default
              const repostPhaseId = response.ConversationPhaseId;
              conversationPhaseDefault =
                repostPhaseId !== undefined &&
                repostPhaseId !== null &&
                phaseItems.some(p => p.value === repostPhaseId)
                  ? repostPhaseId
                  : this.findDefaultPhase();
            }

            this.setState(
              {
                layers: this.props.conversation.ConversationLayers || [],
                body: response.Body,
                isEnableEditor: true,
                isNewRepost: true,
                isLoadingRepost: false,
                type: 2,
                attachments: response.Attachments,
                buttonTitle: 'Re-Post',
                replyPhases: phaseItems,
                comboPhaseSelected: conversationPhaseDefault,
              },
              () =>
              {
                // Runs after `layers` is committed, since setReplyLayers reads this.state.layers
                this.setReplyLayers(response.ReplyLayers);
              },
            );
            if (this.props.setShowRepost)
            {
              this.props.setShowRepost();
            }
          })
          .catch(() =>
          {
            this.setState({
              saveInProgress: false,
              showBodyIsRequired: false,
              showLayerIsRequired: false,
              isLoadingRepost: false,
            });
          });
      }
    }

    // Handle phase updates when editor is enabled
    if (this.state.isEnableEditor)
    {
      const prevPhasesLength = prevProps.conversation?.Phases?.length ?? 0;
      const currentPhasesLength = this.props.conversation?.Phases?.length ?? 0;

      if (currentPhasesLength > 0 && currentPhasesLength !== prevPhasesLength)
      {
        const items: PhaseOption[] = [];
        items.push({
          value: 0,
          label: 'All Phases',
        });

        for (let index = 0; index < this.props.conversation.Phases!.length; index++)
        {
          const phase = this.props.conversation.Phases![index];
          if (!phase) continue;
          const item: PhaseOption = {
            value: phase.ConversationPhaseId,
            label: phase.Title,
          };
          items.push(item);
        }

        const conversationPhaseDefault = this.findDefaultPhase();

        this.setState({ replyPhases: items, comboPhaseSelected: conversationPhaseDefault });
      }
    }
  }

  callbackDisableEditor(functionDisableEditor: unknown): void
  {
    this.setState({ functionCallback: functionDisableEditor });
  }

  onChangeLayer(
    itemsSelected: ConversationLayer[] | { ConversationLayers?: ConversationLayer[] },
    tagPeopleList?: boolean,
  ): void
  {
    // CardConversationLayers passes the full Conversation object; extract the layers array
    const layersList: ConversationLayer[] = Array.isArray(itemsSelected)
      ? itemsSelected
      : ((itemsSelected as any).ConversationLayers ?? []);
    const order = [...layersList];
    const selectedValuesCopy = order.map(item => item.LayerId);

    let callGetPeopleLists = false;
    if (tagPeopleList !== undefined)
    {
      callGetPeopleLists = tagPeopleList;
    }
    else
    {
      callGetPeopleLists = selectedValuesCopy.length !== this.state.layersSelected.length;
    }

    const firstLayer = order[0];
    const resolvedColor =
      firstLayer
        ? firstLayer.LayerColor || (firstLayer as any).Color || '#ededed'
        : '#ededed';

    this.setState(
      { layersSelectedIds: selectedValuesCopy, layersSelected: order, activeLayerColor: resolvedColor },
      () =>
      {
        if (
          this.summernoteCorgeeElement &&
        typeof this.summernoteCorgeeElement === 'object' &&
        'getPeopleTagList' in this.summernoteCorgeeElement
        )
        {
          (this.summernoteCorgeeElement as any).getPeopleTagList(callGetPeopleLists);
        }
      });
  }

  onSaveReply(e: React.FormEvent): void
  {
    e.preventDefault();

    let newTemporalImportant = false;
    const { layersSelected, saveInProgress, previousBody, attachments, type } = this.state;

    // The editor propagates its content debounced; read it directly on save.
    const liveBody = (this.summernoteCorgeeElement as any)?.getContent?.();
    const body = typeof liveBody === 'string' ? liveBody : this.state.body;

    if (saveInProgress === true && previousBody === body.replace('&amp;', '&'))
    {
      return;
    }

    newTemporalImportant =
      this.pendingImportant ||
      document.querySelector('.btn-important-mark.btn-infowindow-important') !== null;

    const htmlBody = this.extractTextFromHtml(body);
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = body;
    const imageTags = tempDiv.querySelectorAll('img');

    const hasUnallowedFiles = attachments.filter(x => !x.AllowedSize).length > 0;
    let bodyIsRequired = false;
    let layerIsRequired = false;

    if (
      (htmlBody === '' || htmlBody.trim().length === 0) &&
      imageTags.length === 0 &&
      attachments.length === 0
    )
    {
      bodyIsRequired = true;
    }

    if (layersSelected.length === 0)
    {
      layerIsRequired = true;
    }

    this.setState({
      showBodyIsRequired: bodyIsRequired,
      showLayerIsRequired: layerIsRequired,
      isNewRepost: false,
    });

    if (
      this.props.SocketConnectionId === undefined ||
      this.props.SocketConnectionId === null ||
      this.props.SocketConnectionId === ''
    )
    {
      if (this.props.corgeeFunctions && this.props.corgeeFunctions.getSocketConnectionId)
      {
        (this.props as any).SocketConnectionId = this.props.corgeeFunctions.getSocketConnectionId();
      }
    }

    if (bodyIsRequired === false && layerIsRequired === false && !hasUnallowedFiles)
    {
      const replyItem: ReplyItem = {
        ReplyId: type === 2 && this.props.itemRepost ? this.props.itemRepost.ReplyId : 0,
        ConversationId: this.props.conversation.ConversationId,
        ReplyLayers: [],
        Attachments: attachments,
        Body: body.replace('&amp;', '&'),
        Tags: this.getTagsInBody(body),
        SocketConnectionId:
          this.props.SocketConnectionId !== undefined && this.props.SocketConnectionId !== null
            ? this.props.SocketConnectionId
            : '',
        type: type,
      };

      replyItem.ReplyLayers = layersSelected.map(layerItem => ({
        LayerId: layerItem.LayerId,
        LayerColor: layerItem.LayerColor || (layerItem as any).Color || '',
        LayerName: layerItem.LayerName || (layerItem as any).Name || '',
        ReplyId: 0,
      }));

      replyItem.possibleTags = [];
      if (
        this.summernoteCorgeeElement &&
        typeof this.summernoteCorgeeElement === 'object' &&
        'setPossibleTagList' in this.summernoteCorgeeElement
      )
      {
        replyItem.possibleTags = (this.summernoteCorgeeElement as any).setPossibleTagList();
      }

      replyItem.Body = this.disableChecklist(replyItem.Body);

      if (replyItem.Body === '<p><br></p>')
      {
        replyItem.Body = '<span></span>';
      }

      this.setState({ saveInProgress: true, previousBody: body.replace('&amp;', '&') });

      replyItem.CreatedBy =
        this.props.userData != null
          ? this.props.userData.personName
          : localStorage.getItem(CorgeeStorageHelper.appPrefix() + '_givenname') ||
            this.props.conversation.CreatedBy ||
            'Unknown';

      let img = localStorage.getItem(CorgeeStorageHelper.appPrefix() + '_imageprofile') || '';
      if (img === '')
      {
        // Normalize URL to avoid double slashes
        const baseUrl = this.props.config.weburl.replace(/\/$/, '');
        img = baseUrl + '/Images/user.png';
      }

      replyItem.ImageName =
        this.props.userData != null && this.props.userData.imageProfile
          ? this.props.userData.imageProfile
          : img;
      replyItem.CopyBody = replyItem.Body;
      replyItem.Body = replyItem.Body.replace(/<img[^>]*>/g, '');

      const divhtml = document.createElement('div');
      divhtml.innerHTML = replyItem.Body;
      divhtml.classList.add('appendMovingDots');
      replyItem.Body = divhtml.outerHTML;

      if (replyItem.type === 2)
      {
        replyItem.ReplyId_Repost = replyItem.ReplyId;
      }

      replyItem.ReplyId = 0;
      replyItem.reactSelfUpdate = false;
      replyItem.TemporalReply = true;
      replyItem.reactions = [];

      this.setState({ isEnableEditor: false });

      if (this.props.conversation.HasPhases && this.props.conversation.HasPhases === true)
      {
        replyItem.ConversationPhaseId =
          this.state.comboPhaseSelected === undefined || this.state.comboPhaseSelected === null
            ? this.props.phaseSelected?.ConversationPhaseId
            : this.state.comboPhaseSelected;

        const repPhase = this.state.replyPhases.find(
          x => x.value === replyItem.ConversationPhaseId,
        );
        replyItem.PhaseName =
          repPhase !== undefined ? repPhase.label : this.props.phaseSelected?.Title || '';
      }

      if (this.props.onAddReply)
      {
        this.props.onAddReply(this.props.conversation.ConversationId, replyItem, false, true);
      }

      setTimeout(() =>
      {
        ReplyApi.addReply(this.props.api as any, replyItem as any)
          .then((response: ReplyItem) =>
          {
            replyItem.CreatedBy = response.CreatedBy;
            replyItem.CreatedAt = response.CreatedAt;
            replyItem.Attachments = response.Attachments;
            replyItem.ReplyLayers = response.ReplyLayers;
            replyItem.CreatedById = response.CreatedById;
            replyItem.ReplyId = response.ReplyId;
            replyItem.Body = response.Body;
            replyItem.IsEnable = response.IsEnable;
            if (response.ImageName)
            {
              replyItem.ImageName = response.ImageName;
            }
            replyItem.IsFavorite = false;
            replyItem.FavoriteCount = 0;
            replyItem.reactions = [];
            replyItem.type = 1;
            replyItem.OriginalConversationId = response.OriginalConversationId;
            replyItem.TemporalReply = false;
            replyItem.SocketConnectionId = this.props.SocketConnectionId || '';
            replyItem.IsImportant = newTemporalImportant;

            if (this.props.onAddReply)
            {
              this.props.onAddReply(this.props.conversation.ConversationId, replyItem, true, false);
            }

            conversationBus.emit('reply-added', {
              conversationId: this.props.conversation.ConversationId,
              reply: replyItem,
            });

            if (this.props.setIsFromAddReply)
            {
              this.props.setIsFromAddReply(true);
            }

            this.pendingImportant = false;
            this.setState({
              isEnableEditor: false,
              body: '',
              layers: this.props.conversation.ConversationLayers || [],
              showBodyIsRequired: false,
              showLayerIsRequired: false,
              saveInProgress: false,
              attachments: [],
              buttonTitle: 'Reply',
              isImportant: false,
            });

            if (newTemporalImportant)
            {
              ConversationApi.updateReplyImportant(this.props.api as any, {
                ConversationId: this.props.conversation.ConversationId,
                ReplyId: response.ReplyId,
                IsImportant: true,
                SocketConnectionId: this.props.SocketConnectionId ?? '',
              })
                .then(() =>
                {
                  ConversationApi.SetConversationsAsViewed(this.props.api as any, {
                    ConversationIds: String(this.props.conversation.ConversationId),
                  });
                })
                .catch((error: any) =>
                {
                  console.error(error);
                });
            }
            else
            {
              ConversationApi.SetConversationsAsViewed(this.props.api as any, {
                ConversationIds: String(this.props.conversation.ConversationId),
              });
            }
          })
          .catch(() =>
          {
            this.setState({
              saveInProgress: false,
              showBodyIsRequired: false,
              showLayerIsRequired: false,
            });
          });
      }, 0);
    }
  }

  getTagsInBody(bodyTags: string): Tag[]
  {
    const listTags: Tag[] = [];
    try
    {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = bodyTags;
      const taggedPeople = tempDiv.querySelectorAll('span[person-id]');

      for (let i = 0; i < taggedPeople.length; i++)
      {
        const personId = taggedPeople[i]?.getAttribute('person-id');
        if (personId)
        {
          listTags.push({
            PersonId: parseInt(personId),
            ConversationId: 0,
            ReplyId: 0,
            ReplyFollowing: 0,
          });
        }
      }

      return listTags;
    }
    catch (err)
    {
      console.warn(err);
      return [];
    }
  }

  onKeyDownEditor(e: React.KeyboardEvent): void
  {
    // Escape key code
    if (e.keyCode === 27)
    {
      this.closeEditor();
    }
  }

  onDropFiles(e: File[] | FileList | DragEvent): void
  {
    if (
      this.fileUploadItem &&
      typeof this.fileUploadItem === 'object' &&
      'onDrop' in this.fileUploadItem
    )
    {
      (this.fileUploadItem as any).onDrop(e);
    }
  }

  closeEditor(deleteDraft?: boolean): void
  {
    switch (deleteDraft)
    {
      case true: {
        if (this.state.isBlockBack)
        {
          window.removeEventListener('popstate', this.handlePopState);
        }
        else if (this.state.functionCallback)
        {
          (this.state.functionCallback as any)(true);
        }
        this.setState({
          isEnableEditor: false,
          showBodyIsRequired: false,
          body: '',
          attachments: [],
          isNewRepost: false,
          buttonTitle: 'Reply',
          showConfirmationModal: false,
          isBlockBack: false,
        });
        break;
      }
      case false: {
        this.setState({ showConfirmationModal: false, isBlockBack: false });
        break;
      }
      default: {
        // validate text, copied images, uploaded Attachments, and uploading media
        if (
          this.state.body.length > 0 &&
          (this.extractTextFromHtml(this.state.body).length > 0 ||
            this.state.attachments.length > 0 ||
            this.state.isUploadingFile)
        )
        {
          const existingStyles = document
            .querySelector('.ui-dialog.react-draggable')
            ?.getAttribute('style');
          if (existingStyles && !existingStyles.includes('z-index:8'))
          {
            const dialogElement = document.querySelector('.ui-dialog.react-draggable');
            if (dialogElement)
            {
              dialogElement.setAttribute('style', existingStyles + 'z-index:8 !important');
            }
          }
          this.setState({ showConfirmationModal: true });
        }
        else
        {
          this.closeEditor(true);
        }
        break;
      }
    }
  }

  onEnableEditor(e: React.MouseEvent): void
  {
    const { conversation } = this.props;
    const items: PhaseOption[] = [];
    e.preventDefault();
    let conversationPhaseDefault = 0;

    if (conversation.HasPhases)
    {
      if (conversation.Phases && conversation.Phases.length > 0)
      {
        items.push({
          value: 0,
          label: 'All Phases',
        });

        for (let index = 0; index < conversation.Phases.length; index++)
        {
          const phase = conversation.Phases[index];
          if (!phase) continue;
          const item: PhaseOption = {
            value: phase.ConversationPhaseId,
            label: phase.Title,
          };
          items.push(item);
        }
      }
      conversationPhaseDefault = this.findDefaultPhase();
    }

    this.setDefaultLayer();
    this.setState({
      body: '',
      isEnableEditor: true,
      replyPhases: items,
      comboPhaseSelected: conversationPhaseDefault,
    });
  }

  setDefaultLayer(): void
  {
    const layerIdDefault = CorgeeStorageHelper.layerId();
    const layersToHide = CorgeeStorageHelper.getLayersToHide();

    const layers = this.state.layers.filter(x => x.LayerId !== 0);

    let layersSelectedIds = layers && layers.length > 0 ? [layers[0]!.LayerId] : [];
    let layersSelected = layers && layers.length > 0 ? [layers[0]!] : [];

    if (layerIdDefault)
    {
      const hideLayerFilter = (layersToHide || []).filter(
        hideLayer => parseInt(hideLayer as any) === parseInt(layerIdDefault),
      );
      if (hideLayerFilter.length === 0)
      {
        if (layerIdDefault && this.state.layers)
        {
          const layerIndexDefault = this.state.layers.findIndex(
            item => item.LayerId === parseInt(layerIdDefault),
          );
          if (layerIndexDefault >= 0)
          {
            layersSelectedIds = [this.state.layers[layerIndexDefault]!.LayerId];
            layersSelected = [this.state.layers[layerIndexDefault]!];
          }
        }
      }
    }

    this.setState({ layersSelectedIds: layersSelectedIds, layersSelected: layersSelected });
  }

  onApplyStyle(): void
  {
    if (this.layersMultiSelectRef)
    {
      const selectControl = (this.layersMultiSelectRef as any).control;
      if (selectControl instanceof HTMLElement)
      {
        const rect = selectControl.getBoundingClientRect();
        const style: CSSProperties = {
          position: 'fixed',
          top: rect.top + 35,
          left: rect.left,
          width: selectControl.offsetWidth,
        };
        this.setState({ listMenuStyle: style });
      }
    }
  }

  onChangeSummernote(content: string): void
  {
    this.setState({ body: content });
  }

  setReplyLayers(layers: ReplyLayer[]): void
  {
    const layersIds: number[] = [];
    const layersSelected: ConversationLayer[] = [];

    // Keep every layer of the reply, ordered by LayerId
    const orderedLayers = [...layers].sort((a, b) => a.LayerId - b.LayerId);

    for (let x = 0; x < orderedLayers.length; x++)
    {
      const replyLayer = orderedLayers[x]!;
      const cardLayer = this.state.layers.find(item => item.LayerId === replyLayer.LayerId);

      layersIds.push(replyLayer.LayerId);
      layersSelected.push(cardLayer ?? replyLayer);
    }

    // Repost skips onChangeLayer, so resolve the color here
    const firstLayer = [...layers].sort(
      (a, b) => (a.PriorityInConfigValue || 0) - (b.PriorityInConfigValue || 0),
    )[0];
    const resolvedColor =
      firstLayer
        ? firstLayer.LayerColor || (firstLayer as any).Color || '#ededed'
        : '#ededed';

    this.setState({
      layersSelectedIds: layersIds,
      layersSelected: layersSelected,
      activeLayerColor: resolvedColor,
    });
  }

  onChangeFileUpload(filesUploaded: Attachment[] | boolean): void
  {
    // check if the param is true, this validation allows to disable an early push on reply button
    let showWarning = filesUploaded === true ? true : false;

    if (Array.isArray(filesUploaded))
    {
      const uploadProgress = filesUploaded.map(x => x.Progress).find(x => x && x < 100);
      showWarning = uploadProgress !== undefined;
    }

    if (showWarning)
    {
      this.setState({ isUploadingFile: true });
    }
    else
    {
      this.setState({
        attachments: Array.isArray(filesUploaded) ? filesUploaded : [],
        isUploadingFile: false,
      });
    }
  }

  onRemoveAttachment(index: number): void
  {
    const copyAttachments = [...this.state.attachments];
    copyAttachments.splice(index, 1);
    this.setState({ attachments: copyAttachments });
  }

  turnOffNewRepost(): void
  {
    this.setState({ isNewRepost: false });
  }

  disableChecklist(content: string): string
  {
    const div = document.createElement('div');
    div.innerHTML = content;

    const checkboxes = div.querySelectorAll('.note-editor-checkbox');
    checkboxes.forEach(checkbox =>
    {
      checkbox.setAttribute('disabled', 'true');
    });

    content = div.innerHTML;

    try
    {
      // Validate HTML
      if (content === '')
      {
        content = '';
      }
    }
    catch (err)
    {
      content = content.replace('<p><br></p>', '');
      content = '<p>' + content + '</p>';
    }

    return content;
  }

  handleChangePhaseSumernote(event: PhaseOption | null): void
  {
    if (!event) return;

    this.setState({ comboPhaseSelected: event.value });

    const localPhasesJson = localStorage.getItem(
      CorgeeStorageHelper.appPrefix() + '_ConversationReplyPhaseDefault',
    );
    let localPhases: Array<{ ConversationId: number; ConversationPhaseId: number }> | null = null;

    try
    {
      localPhases = localPhasesJson ? JSON.parse(localPhasesJson) : null;
    }
    catch
    {
      localPhases = null;
    }

    if (localPhases === undefined || localPhases === null)
    {
      const item = [
        {
          ConversationId: this.props.conversation.ConversationId,
          ConversationPhaseId: event.value,
        },
      ];

      localStorage.setItem(
        CorgeeStorageHelper.appPrefix() + '_ConversationReplyPhaseDefault',
        JSON.stringify(item),
      );
    }
    else
    {
      let index = -1;

      for (let i = 0; i < localPhases.length; i++)
      {
        const lp2 = localPhases[i];
        if (lp2 && lp2['ConversationId'] === this.props.conversation.ConversationId)
        {
          index = i;
          break;
        }
      }

      const item = {
        ConversationId: this.props.conversation.ConversationId,
        ConversationPhaseId: event.value,
      };

      if (index !== -1)
      {
        localPhases.splice(index, 1);
        localPhases.push(item);
      }
      else
      {
        localPhases.push(item);
      }

      if (localPhases.length > 100)
      {
        localPhases.splice(0, 1);
      }

      localStorage.setItem(
        CorgeeStorageHelper.appPrefix() + '_ConversationReplyPhaseDefault',
        JSON.stringify(localPhases),
      );
    }
  }

  render(): ReactNode
  {
    const { api, conversation, isConversationDetailsView, isInfowindowViewCard } = this.props;
    const {
      isEnableEditor,
      body,
      layersSelectedIds,
      layersSelected,
      showBodyIsRequired,
      isUploadingFile,
      showLayerIsRequired,
      attachments,
      isNewRepost,
      isLoadingRepost,
      buttonTitle,
      showConfirmationModal,
      comboPhaseSelected,
      replyPhases,
      activeLayerColor,
    } = this.state;

    const firstLayerColor = activeLayerColor;

    void CorgeeStorageHelper.getAllLayers();

    return (
      <div className="corgee_com_card-add-replay-container">
        {isEnableEditor === false && isLoadingRepost === false && (
          <div className="corgee_com_card-add-replay-post-action">
            <textarea
              className="text-reply"
              placeholder="Post a reply..."
              tabIndex={-1}
              onClick={this.onEnableEditor}
            ></textarea>
          </div>
        )}
        {isEnableEditor === false && isLoadingRepost === true && (
          <div className="corgee_com_card-add-replay-loading" role="status" aria-live="polite">
            <span className="corgee_com_card-add-replay-loading-spinner" aria-hidden="true"></span>
            <span>Loading re-post...</span>
          </div>
        )}
        {isEnableEditor === true && conversation.HasPhases === true && (
          <div className="summernote-phases">
            <Select
              className="select-summernote-phases"
              classNamePrefix="reply-phase-select"
              placeholder="Select a Phase"
              isClearable={false}
              isSearchable={false}
              value={replyPhases.find(p => p.value === comboPhaseSelected) || null}
              options={replyPhases}
              onChange={this.handleChangePhaseSumernote}
            />
          </div>
        )}
        {isEnableEditor === true && (
          <SummernoteCorgee
            ref={(ref: any) => (this.summernoteCorgeeElement = ref)}
            selectorContainer=".corgee_com_card-add-replay-container"
            conversationId={conversation.ConversationId}
            onChangeBody={this.onChangeSummernote}
            body={body}
            layerColor={firstLayerColor}
            textHeight=""
            layers={layersSelected}
            api={this.props.api as any}
            isInfowindowViewCard={isInfowindowViewCard}
            projectId={conversation.ProjectId}
            configValueId={conversation.ConfigValueId}
            isAddReply={true}
            onKeyDown={this.onKeyDownEditor as any}
            onDropFiles={this.onDropFiles as any}
            {...(this.props as any)}
            onUpdateTemporalImportant={this.onUpdateTemporalImportant}
          >
            <div>
              {isUploadingFile === true ? (
                <div className="corgee_com_validation-message">Uploading file, please wait.</div>
              ) : showBodyIsRequired === true ? (
                <div className="corgee_com_validation-message">Enter a valid message.</div>
              ) : null}

              <div
                className="corgee_com_card-add-replay-uploader"
                style={{ borderColor: firstLayerColor, marginTop: 2 }}
              >
                {React.createElement(FileUpload as any, {
                  ref: (ref: any) => (this.fileUploadItem = ref),
                  onChangeFileUpload: this.onChangeFileUpload,
                  onRemoveAttachment: this.onRemoveAttachment,
                  config: api,
                  isNewRepost: isNewRepost,
                  attachments: attachments,
                  turnOffNewRepost: this.turnOffNewRepost,
                })}
              </div>

              <div className="corgee_com_card-publish-options">
                <div className="corgee_com_card-publish-action">
                  <button
                    className="corgee_com_button corgee_com_button-primary btnChangeColorWithLayer"
                    onClick={this.onSaveReply}
                    style={{ backgroundColor: firstLayerColor, borderColor: firstLayerColor }}
                    disabled={isUploadingFile}
                  >
                    {buttonTitle}
                  </button>
                </div>

                <div
                  className="corgee_com_card-publish-layers"
                  style={{ position: 'relative', zIndex: 1000 }}
                >
                  <div className="corgee_com_card-item-security-settings-container">
                    <div className="corgee_com_card-item-security-settings-label">Layers</div>

                    <div
                      className={
                        isConversationDetailsView === true
                          ? 'corgee_com_card-layers-container-widget'
                          : 'corgee_com_card-layers-container-widget'
                      }
                      style={{ borderColor: firstLayerColor }}
                    >
                      {React.createElement(CardConversationLayers as any, {
                        apiConfig: api,
                        conversation: conversation,
                        ref: (ref: any) => (this.layersMultiSelectRef = ref),
                        isNew: true,
                        disableAutoSave: false,
                        onChangedLayers: this.onChangeLayer,
                        addLayerToCard: this.props.onAddLayerToCard,
                        addLayerToProject: this.props.onAddLayerToProject,
                        isConversationDetailsView: isConversationDetailsView,
                        onSetFunctionsCardLayers: this.props.onSetFunctionsCardLayers,
                        isEnableEditor: isEnableEditor,
                        callbackDisableEditor: this.callbackDisableEditor,
                        isNewRepost: isNewRepost,
                        layersSelectedIds: layersSelectedIds,
                        isInlineWidget: true,
                        restrictToConversationLayers: true,
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {showLayerIsRequired === true && (
                <div className="corgee_com_validation-message">Select a layer.</div>
              )}
            </div>
          </SummernoteCorgee>
        )}

        <CustomModal show={showConfirmationModal}>
          <md-dialog
            className="md-transition-in"
            role="dialog"
            tabIndex={-1}
            style={{ opacity: '1', position: 'static' }}
            id="draftConfirmationModal"
          >
            <form className="">
              <md-toolbar style={{ cursor: 'default' }}>
                <div className="md-toolbar-tools">
                  <div className="popup-header-title">Confirm Action</div>
                </div>
                <div
                  className="close-control modal-icon-close-pos"
                  role="button"
                  tabIndex={0}
                  onClick={() => this.closeEditor(false)}
                >
                  <i className="icon-incorrect-icon"></i>
                </div>
              </md-toolbar>
              <md-dialog-content style={{ display: 'table' }} id="dialog_23">
                <div className="md-dialog-content delete-item-modal">
                  Are you sure you want to delete? Draft will be missed.
                </div>
              </md-dialog-content>

              <md-dialog-actions {...({ layout: 'row' } as any)} className="layout-row">
                <span {...({ flex: '' } as any)} className="flex"></span>
                <button
                  className="modal-window-button confirm-cancel md-button md-ink-ripple"
                  type="button"
                  onClick={() => this.closeEditor(false)}
                >
                  <span>Cancel</span>
                </button>
                <button
                  className="modal-window-button confirm-continue md-button md-ink-ripple"
                  type="button"
                  onClick={() => this.closeEditor(true)}
                >
                  <span>Confirm</span>
                </button>
              </md-dialog-actions>
            </form>
            <div className="md-dialog-focus-trap" tabIndex={0}></div>
          </md-dialog>
        </CustomModal>
      </div>
    );
  }
}

export default ConversationCardAddReply;
